import { useContext } from "react";
import { AppContext } from "../App";
import "./../css/Brands.css";
import Label from "../components/Label";
import PopUp from "../components/PopUp";
import CloseIcon from "../components/icons/CloseIcon";

const SKIP_STORE_BRAND_POPUP_UNTIL_KEY = "skip-store-brand-popup-until";

function Brands() {
	const {
		mainSettings,
		setBrand,
		brand,
		markUserChange,
		brandSelectionAtOrderInit,
		hotel,
		hotelBrandSelectionRequired,
		hotelAvailableBrands,
		brandPopupVisible,
		setBrandPopupVisible,
		brandPopupRedirect,
	} = useContext(AppContext);
	const queryParams = new URLSearchParams(window.location.search);
	const redirectPath = queryParams.get("redirect");
	const isBrandSelectionAtOrderInit = brandSelectionAtOrderInit;
	const isHotelBrandSelection = hotel && hotelAvailableBrands.length > 1;
	const hotelScopedBrands = isHotelBrandSelection || hotelBrandSelectionRequired ? hotelAvailableBrands : [];
	const selectableBrands =
		hotelScopedBrands.length > 0
			? hotelScopedBrands
			: [
					{
						key: "main",
						value: "main",
						name: mainSettings.global.name,
						img: mainSettings.global.logo,
					},
					...(mainSettings.mandant?.childs || []).map((b) => ({
						key: "child-" + b.id,
						value: b,
						name: b.name,
						img: b.img,
					})),
				];
	const effectiveRedirect = brandPopupVisible ? brandPopupRedirect : redirectPath;
	const isPopupMode = (isBrandSelectionAtOrderInit || hotelBrandSelectionRequired || isHotelBrandSelection) && !!effectiveRedirect;

	const navigateTo = (path) => {
		window.history.pushState({}, "", path);
		window.dispatchEvent(new PopStateEvent("popstate"));
	};

	const getBrandKey = (value) => {
		if (!value) return "";
		if (value === "main") return "main";
		return "child-" + value.id;
	};

	const selectBrand = (selectedBrand) => {
		const brandChanged = getBrandKey(selectedBrand) !== getBrandKey(brand);

		if (isPopupMode) {
			sessionStorage.setItem(SKIP_STORE_BRAND_POPUP_UNTIL_KEY, (Date.now() + 15000).toString());
			if (brandPopupVisible) setBrandPopupVisible(false);
			if (brandChanged) {
				markUserChange?.();
				setBrand(selectedBrand);
			}
			navigateTo(effectiveRedirect);
			return;
		}

		if (brandChanged) markUserChange?.();
		setBrand(selectedBrand);
	};

	if (isPopupMode) {
		return (
			<PopUp size="sm" className="brands-init-popup">
				<div className="header">
					<div>
						<Label number={186} />
					</div>
					{!hotelBrandSelectionRequired && (
						<button
							onClick={() => {
								if (brandPopupVisible) setBrandPopupVisible(false);
								if (redirectPath) navigateTo(redirectPath);
							}}
						>
							<CloseIcon />
						</button>
					)}
				</div>
				<div className="content brands-popup-content">
					<div className="list">
						{selectableBrands.map((b, i) => (
							<button key={b.key || i} onClick={() => selectBrand(b.value)}>
								<img src={b.img} alt={b.name} />
							</button>
						))}
					</div>
				</div>
			</PopUp>
		);
	}

	if (isBrandSelectionAtOrderInit) return null;

	return (
		<div className="brands">
			<div className="content">
				<h1 className="title">
					<Label number={186} />
				</h1>
				<div className="list">
					{selectableBrands.map((b, i) => (
						<button key={b.key || i} onClick={() => selectBrand(b.value)}>
							<img src={b.img} alt={b.name} />
						</button>
					))}
				</div>
			</div>
		</div>
	);
}

export default Brands;
